import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { Footer } from '@/components/layout/Footer';
import { TopNav } from '@/components/layout/TopNav';

/** For anonymous, unauthenticated pages that still want the standard chrome (a public job listing). */
export function PublicLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopNav />
      <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, pt: 10, pb: 4 }}>
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
}
